import { Link } from 'react-router-dom';
import { LanderTopDomain } from '../api/models';
import { GrowthDelta } from './GrowthStatistic';

interface Props {
    domains?: LanderTopDomain[] | null;
    loading?: boolean;
    limit?: number;
}

export function LanderLeaderboard({ domains, loading, limit = 10 }: Props) {
    if (loading) {
        return <span className="text-text-3 text-sm">Loading...</span>;
    }

    const ranked = (domains ?? []).slice(0, limit);
    if (ranked.length === 0) {
        return <span className="text-text-3 text-sm">No lander traffic in this period.</span>;
    }

    const max = Math.max(...ranked.map((d) => d.visitors));

    return (
        <div className="flex flex-col gap-0.5">
            {ranked.map((d, idx) => (
                <Link
                    key={d.domain}
                    to={`/landers/${encodeURIComponent(d.domain)}`}
                    title={`${d.visitors.toLocaleString()} uniques, previous period ${d.previousVisitors.toLocaleString()}`}
                    className="group relative flex items-center gap-2 px-1.5 py-1 rounded overflow-hidden hover:bg-bg no-underline"
                >
                    <span
                        aria-hidden
                        className="absolute inset-y-0 left-0 bg-accent/10 rounded"
                        style={{ width: max > 0 ? `${(d.visitors / max) * 100}%` : 0 }}
                    />
                    <span className="relative text-text-3 font-mono text-2xs w-4 text-right tabular-nums">{idx + 1}</span>
                    <span className="relative flex-1 min-w-0 truncate text-accent font-medium text-sm group-hover:opacity-80">
                        {d.domain}
                    </span>
                    <span className="relative text-text font-mono text-sm tabular-nums">
                        {d.visitors.toLocaleString()}
                    </span>
                    <span className="relative w-[66px] text-right">
                        <GrowthDelta currentValue={d.visitors} previousValue={d.previousVisitors} />
                    </span>
                </Link>
            ))}
        </div>
    );
}

export default LanderLeaderboard;
